import React, { useState,useEffect } from "react";
import { motion } from "framer-motion";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "../../Styles/AddService.css";
import Header from "../../Core/Header";
import { Section } from "../../Core/Section";
import { patientList } from "../../Services/Operations/ProductAPI";
import { useSelector } from "react-redux";

const AddService = () => {
  const [step, setStep] = useState(1);
    const [patient, setPatient] = useState([]);
  const token = useSelector((state) => state.user.token);
  const [formData, setFormData] = useState({
    patientName: "",
    alternativeMobile: "",
    issue: "",
    address: "",
    images: [],
    pickupDate: null,
    servicePerson: "",
  });

  const patientNames = [
    "John Doe",
    "Jane Smith",
    "Robert Johnson",
    "Emily Davis",
    "Michael Wilson",
  ];

  const servicePersons = [
    "Alex Technician",
    "Sam Specialist",
    "Taylor Expert",
    "Jordan Professional",
  ];

      useEffect(() => {
      const fetchPatientList = async () => {
        try {
          const response = await patientList(token);
          console.log("response patientList: ",response)
          setPatient(response);
        } catch (error) {
          console.error("Error:", error);
        }
      };
  
      fetchPatientList();
    }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleImageUpload = (e) => {
    const files = Array.from(e.target.files);
    const newImages = files.map((file) => ({
      file,
      preview: URL.createObjectURL(file),
    }));
    setFormData((prev) => ({
      ...prev,
      images: [...prev.images, ...newImages],
    }));
  };

  const removeImage = (index) => {
    const newImages = [...formData.images];
    URL.revokeObjectURL(newImages[index].preview);
    newImages.splice(index, 1);
    setFormData((prev) => ({ ...prev, images: newImages }));
  };

  const nextStep = () => {
    setStep((prev) => prev + 1);
  };

  const prevStep = () => {
    setStep((prev) => prev - 1);
  };

  const submitForm = () => {
    console.log("Form submitted:", formData);
    alert("Service request submitted successfully!");
  };



  return (
    <div id="main_content">
      <Header />
      <div className="page">
        <Section />
        <div className="form-container">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="form-card"
          >
            <div className="progress-container">
              <div className="progress-steps">
                {[1, 2, 3].map((stepNumber) => (
                  <React.Fragment key={stepNumber}>
                    <div className="progress-step">
                      <div
                        className={`progress-number ${
                          step >= stepNumber
                            ? "bg-indigo-600 text-white"
                            : "bg-gray-200 text-gray-600"
                        }`}
                      >
                        {stepNumber}
                      </div>
                      <span
                        className={`progress-label ${
                          step >= stepNumber
                            ? "text-indigo-600 font-medium"
                            : "text-gray-500"
                        }`}
                      >
                        {stepNumber === 1 && "Details"}
                        {stepNumber === 2 && "Schedule"}
                        {stepNumber === 3 && "Assign"}
                      </span>
                    </div>
                    {stepNumber < 3 && (
                      <div
                        className={`progress-connector ${
                          step > stepNumber ? "bg-indigo-600" : "bg-gray-200"
                        }`}
                      ></div>
                    )}
                  </React.Fragment>
                ))}
              </div>
            </div>

            <div className="form-content">
              {step === 1 && (
                <motion.div
                  initial={{ opacity: 0, x: -20 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.3 }}
                >
                  <h2 className="form-title">Service Request Details</h2>

                  <div className="space-y-6">
                    <div className="form-group">
                      <label className="form-label">Patient Name</label>
                      <select
                        name="patientName"
                        value={formData.patientName}
                        onChange={handleInputChange}
                        className="form-input"
                        required
                      >
                        <option value="">Select a patient</option>
                        {patient.map((name) => (
                          <option key={name?.firstName} value={name?.id}>
                            {name?.firstName} {name?.lastName}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="form-group">
                      <label className="form-label">
                        Alternative Mobile No (Optional)
                      </label>
                      <input
                        type="tel"
                        name="alternativeMobile"
                        value={formData.alternativeMobile}
                        onChange={handleInputChange}
                        className="form-input"
                        placeholder="Enter alternative number"
                      />
                    </div>

                    <div className="form-group">
                      <label className="form-label">Issue Description</label>
                      <textarea
                        name="issue"
                        value={formData.issue}
                        onChange={handleInputChange}
                        rows={3}
                        className="form-input form-textarea"
                        placeholder="Describe the issue..."
                        required
                      />
                    </div>

                    <div className="form-group">
                      <label className="form-label">Pickup Address</label>
                      <textarea
                        name="address"
                        value={formData.address}
                        onChange={handleInputChange}
                        rows={3}
                        className="form-input form-textarea"
                        placeholder="Enter full pickup address..."
                        required
                      />
                    </div>

                    <div className="form-group">
                      <label className="form-label">
                        Upload Product Images
                      </label>
                      <div className="file-upload">
                        <div className="file-upload-content">
                          <div className="flex text-sm text-gray-600">
                            <label
                              htmlFor="file-upload"
                              className="file-upload-label"
                            >
                              <span className="text-indigo-600 hover:text-indigo-500">
                                Upload files
                              </span>
                              <input
                                id="file-upload"
                                name="file-upload"
                                type="file"
                                className="file-upload-input"
                                multiple
                                onChange={handleImageUpload}
                              />
                            </label>
                            <p className="pl-1">or drag and drop</p>
                          </div>
                          <p className="file-upload-text">
                            PNG, JPG, GIF up to 10MB
                          </p>
                        </div>
                      </div>
                    </div>

                    {formData.images.length > 0 && (
                      <div className="image-preview-container">
                        <h3 className="image-preview-title">Uploaded Images</h3>
                        <div className="image-preview-grid">
                          {formData.images.map((image, index) => (
                            <div key={index} className="image-preview-item">
                              <img
                                src={image.preview}
                                alt={`Product ${index + 1}`}
                                className="image-preview"
                              />
                              <button
                                type="button"
                                onClick={() => removeImage(index)}
                                className="image-delete-btn"
                              >
                                ×
                              </button>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                </motion.div>
              )}

              {step === 2 && (
                <motion.div
                  initial={{ opacity: 0, x: 20 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.3 }}
                >
                  <h2 className="form-title">Pickup Schedule</h2>
                  <div className="space-y-6">
                    <div className="form-group">
                      <label className="form-label">Select Pickup Date</label>
                      <div className="calendar-container">
                        <DatePicker
                          selected={formData.pickupDate}
                          onChange={(date) =>
                            setFormData((prev) => ({
                              ...prev,
                              pickupDate: date,
                            }))
                          }
                          minDate={new Date()}
                          inline
                          calendarClassName="custom-calendar"
                          renderCustomHeader={({
                            date,
                            decreaseMonth,
                            increaseMonth,
                            prevMonthButtonDisabled,
                            nextMonthButtonDisabled,
                          }) => (
                            <div className="calendar-header">
                              <button
                                onClick={decreaseMonth}
                                disabled={prevMonthButtonDisabled}
                                className="calendar-nav-button"
                              >
                                &lt;
                              </button>
                              <span className="calendar-month-year">
                                {date.toLocaleString("default", {
                                  month: "long",
                                })}{" "}
                                {date.getFullYear()}
                              </span>
                              <button
                                onClick={increaseMonth}
                                disabled={nextMonthButtonDisabled}
                                className="calendar-nav-button"
                              >
                                &gt;
                              </button>
                            </div>
                          )}
                        />
                      </div>
                    </div>
                  </div>
                </motion.div>
              )}

              {step === 3 && (
                <motion.div
                  initial={{ opacity: 0, x: 20 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.3 }}
                >
                  <h2 className="form-title">Assign Service Person</h2>
                  <div className="space-y-6">
                    <div className="form-group">
                      <label className="form-label">Service Person</label>
                      <select
                        name="servicePerson"
                        value={formData.servicePerson}
                        onChange={handleInputChange}
                        className="form-input"
                        required
                      >
                        <option value="">Select a service person</option>
                        {servicePersons.map((person) => (
                          <option key={person} value={person}>
                            {person}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="summary-box">
                      <h3 className="summary-title">Request Summary</h3>
                      <div className="space-y-2">
                        <p className="summary-item">
                          <span className="summary-label">Patient:</span>{" "}
                          {formData.patientName || "Not selected"}
                        </p>
                        <p className="summary-item">
                          <span className="summary-label">
                            Alternative Mobile:
                          </span>{" "}
                          {formData.alternativeMobile || "Not provided"}
                        </p>
                        <p className="summary-item">
                          <span className="summary-label">Issue:</span>{" "}
                          {formData.issue || "Not provided"}
                        </p>
                        <p className="summary-item">
                          <span className="summary-label">Address:</span>{" "}
                          {formData.address || "Not provided"}
                        </p>
                        <p className="summary-item">
                          <span className="summary-label">Pickup Date:</span>{" "}
                          {formData.pickupDate
                            ? formData.pickupDate.toLocaleDateString()
                            : "Not selected"}
                        </p>
                        <p className="summary-item">
                          <span className="summary-label">Images:</span>{" "}
                          {formData.images.length} uploaded
                        </p>
                      </div>
                    </div>
                  </div>
                </motion.div>
              )}

              {/* Navigation Buttons */}
              <div className="form-navigation">
                {step > 1 ? (
                  <button
                    type="button"
                    onClick={prevStep}
                    className="form-btn btn-back"
                  >
                    Back
                  </button>
                ) : (
                  <div></div>
                )}

                {step < 3 ? (
                  <button
                    type="button"
                    onClick={nextStep}
                    className="form-btn btn-next"
                    disabled={
                      (step === 1 &&
                        (!formData.patientName ||
                          !formData.issue ||
                          !formData.address)) ||
                      (step === 2 && !formData.pickupDate)
                    }
                  >
                    Next
                  </button>
                ) : (
                  <button
                    type="button"
                    onClick={submitForm}
                    className="form-btn btn-submit"
                    disabled={!formData.servicePerson}
                  >
                    Submit Request
                  </button>
                )}
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default AddService;
